import styled from 'styled-components';

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 8px;

  @media (max-width: ${({ theme }) => theme.mediaQueries.xs}) {
    flex-direction: column;
  }
`;
